<template>

    <app-layout :nav_type="null">

        <!-- Hero Start -->
        <section class="bg-half-170 pb-0 bg-light d-table w-100">
            <div class="container">
                <div class="row justify-content-center">
                    <div class="col-lg-10">
                        <div class="title-heading text-center mt-4 mb-md-5 pb-md-5">
<!--                            <div class="alert alert-light alert-pills text-dark" role="alert">-->
<!--                                <span class="badge rounded-pill bg-success me-1">Start</span>-->
<!--                                <span class="content"> Fill job <a href="job-apply.html" class="text-primary">application</a> now !</span>-->
<!--                            </div>-->
                            <h1 class="heading mb-3">
                                Explore Courses
<!--                                <span class="text-primary typewrite" data-period="2000" data-type='[ "Freelancer", "Developer", "Designer", "UX Developer", "ios Developer" ]'> <span class="wrap"></span> </span>-->
                            </h1>
                            <p class="para-desc mx-auto text-muted">Explore our wide range of courses designed to help you excel in your studies. Whether you're looking for free resources or comprehensive paid programs, we have something for everyone. Start learning today and achieve your academic goals with our expertly crafted materials.</p>
<!--                            <p class="text-muted mb-0 mt-4"><span class="text-dark">Keywords :</span> Web Developer, Web Designer, Php Developer, IOS Developer, etc...</p>-->
                        </div>
                    </div><!--end col-->

<!--                    <div class="col-12 mt-4 pt-3">-->
<!--                        <img src="assets/images/job/home.png" class="img-fluid" alt="">-->
<!--                    </div>&lt;!&ndash;end col&ndash;&gt;-->
                </div><!--end row-->
            </div><!--end container-->
        </section><!--end section-->
        <!-- Hero End -->

        <!-- Courses Start -->
    <section class="section" id="courses">
        <div class="container">
<!--            <div class="row justify-content-center">-->
<!--                <div class="col-12 text-center">-->
<!--                    <div class="section-title mb-4 pb-2">-->
<!--                        <h4 class="title mb-4">Explore Courses</h4>-->
<!--                                                <p class="text-muted para-desc mx-auto mb-0">-->
<!--                                                    Explore our wide range of courses designed to help you excel in your studies. Whether you're looking for free resources or comprehensive paid programs, we have something for everyone. Start learning today and achieve your academic goals with our expertly crafted materials.-->
<!--                                                </p>-->
<!--                    </div>-->
<!--                </div>&lt;!&ndash;end col&ndash;&gt;-->
<!--            </div>&lt;!&ndash;end row&ndash;&gt;-->

            <div class="row">


                <div class="col-lg-4 col-md-6 col-12 mt-4 pt-2" v-for="course in courses?.data">
                    <course-card :course="course"></course-card>
                </div><!--end col-->

                <div class="col-12 mt-4 pt-2 text-center">

                    <Bootstrap5Pagination
                        class="mb-0"
                        :data="courses"
                        :limit="2"
                        :show-disabled="false"
                        :size="'default'"
                        :align="'center'"
                        @pagination-change-page="getResults"
                    />
                </div>
            </div><!--end row-->
        </div><!--end container-->

    </section><!--end section-->
    <!-- Courses End -->

<!--    <div>-->
<!--        <h3 class="text-center">الكورسات</h3><br/>-->

<!--        <form @submit.prevent="getResults">-->
<!--            -->

<!--	  <div class="form-group row">-->
<!--		<label class="col-sm-2 col-form-label">الاسم</label>-->
<!--		<div class="col-sm-10">-->
<!--		                  <input type="text" class="form-control " v-model="q.name">-->
<!--                		  -->
<!--		</div>-->
<!--	  </div>-->

<!--	  <div class="form-group row">-->
<!--		<label class="col-sm-2 col-form-label">النوع</label>-->
<!--		<div class="col-sm-10">-->
<!--		  -->
<!--    <label class="form-check" v-for="(value,key) in form_options?.type">-->
<!--        <input class="form-check-input" type="radio" v-model="q.type" :value="key">-->
<!--        <span class="form-check-label" >-->
<!--            {{ value }}-->
<!--        </span>-->
<!--    </label>-->
<!--    		  -->
<!--		</div>-->
<!--	  </div>-->

<!--	  <div class="form-group row">-->
<!--		<label class="col-sm-2 col-form-label">الوصف</label>-->
<!--		<div class="col-sm-10">-->
<!--		                  <input type="text" class="form-control " v-model="q.description">		  -->
<!--		</div>-->
<!--	  </div>-->

<!--	  <div class="form-group row">-->
<!--		<label class="col-sm-2 col-form-label">محتوى الصفحة التعريفى</label>-->
<!--		<div class="col-sm-10">-->
<!--		                  <input type="text" class="form-control " v-model="q.content">		  -->
<!--		</div>-->
<!--	  </div>-->
<!-- -->


<!--            <div class="form-group">-->
<!--                <button type="submit" class="btn btn-primary">Search </button>-->
<!--            </div>-->
<!--        </form>-->

<!--        <table class="table table-bordered">-->
<!--            <thead>-->
<!--            <tr>-->
<!--                <th>ID</th>-->
<!--                <td>الاسم</td>-->
<!--                <td>النوع</td>-->
<!--                <td>صورة</td>-->
<!--                <td>الوصف</td>-->
<!--                <td>محتوى الصفحة التعريفى</td>-->
<!--            </tr>-->
<!--            </thead>-->
<!--            <tbody>-->
<!--            <tr v-for="item in courses?.data" :key="item.id" >-->
<!--                <td>{{ item.id }}</td>-->
<!--                <td> {{ item?.name }}</td>-->
<!--                <td> {{ item?.type }}</td>-->
<!--                <td> <a v-if="item.image" :href="item.image">{{ item.image }}</a></td>-->
<!--                <td> {{ item?.description }}</td>-->
<!--                <td> {{ item?.content }}</td>-->

<!--                <td>-->
<!--                    <div class="btn-group" role="group">-->
<!--                                                                        <router-link :to="{name: 'courses.show', params: { id: item.id }}" class="btn btn-info">show</router-link>-->
<!--                                                -->
<!--                                                -->
<!--                    </div>-->
<!--                </td>-->
<!--            </tr>-->
<!--            </tbody>-->
<!--        </table>-->

<!--    </div>-->
    </app-layout>
</template>

<script>

import { useToast } from "vue-toastification";
const toast = useToast();
import { Bootstrap5Pagination } from 'laravel-vue-pagination'
import CourseCard from "./courseCard.vue";
import AppLayout from "../../app-layout.vue";

export default {
    components:{
        AppLayout,
        CourseCard,
        Bootstrap5Pagination
    },
    data() {
        return {
            courses: [],
            q: this.$route.query,
            form_options: {},
        }
    },
     created() {
         this.getResults();
        //
        // const id = toast.info('getting options ...', { icon: 'fa-light fa-filter-list'  });
        //
        // const that = this;
        //
        // axios.get('courses/create').then(response => {
        //     toast.dismiss(id);
        //     this.form_options = response.data.elements;
        // }) .catch(function (error) {
        //     toast.dismiss(id);
        //     if (error.response) {
        //         that.validationErrors = error.response.data.errors ;
        //     }
        // });

    },
    methods: {
        getResults ( page = this.$route?.query?.page ?? 1 ) {

            const id = toast.info('Getting content ...', { icon: 'fa-solid fa-download' });

            axios.get('courses', { params : { 'page' : page,'name' : this.q.name,'type' : this.q.type,'description' : this.q.description,'content' : this.q.content  }} ).then(response => {
                toast.dismiss(id);
                this.courses = response.data;

                this.$router.replace({ name: "courses.index", query: { 'page' : page,'name' : this.q.name,'type' : this.q.type,'description' : this.q.description,'content' : this.q.content  }  });
            }, response => {
                toast.dismiss(id);
            });

        },
    }
}
</script>
